



import Seo from '../components/Seo';
import logo from '../assets/images/vine-centre-logo.png';
import building from '../assets/images/vine_centre_advert[1].jpg';
import Button from '@mui/material/Button';

export default function Home() {
  return (
    <>
      <Seo
        title="Vine Centre | Community Hub Belfast"
        description="The Vine Centre is a vibrant community hub in North Belfast, offering support, programmes, and events for all ages. Empowering the community since 1997."
      />
      <div style={{
        maxWidth: 900,
        marginLeft: 32,
        marginRight: 'auto',
        marginTop: 24,
        paddingLeft: 16,
        paddingRight: 16,
      }}>
        {/* Hero Section */}
        <div style={{
          position: 'relative',
          width: '100%',
          height: '55vh',
          minHeight: 320,
          maxHeight: 480,
          overflow: 'hidden',
          borderRadius: 18,
          boxShadow: '0 8px 32px rgba(101,8,52,0.13)',
          background: '#fff',
          margin: 0,
        }}>
          <img
            src={building}
            alt="Vine Centre Building"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center 75%',
              filter: 'brightness(0.72)',
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            background: 'linear-gradient(90deg, rgba(101,8,52,0.55) 0%, rgba(191,192,194,0.25) 100%)',
            textShadow: '0 2px 8px rgba(101,8,52,0.18)',
            textAlign: 'center',
          }}>
            <img
              src={logo}
              alt="Vine Centre Logo"
              style={{
                height: 90,
                marginBottom: 11,
                background: 'rgba(255,255,255,0.92)',
                borderRadius: 16,
                padding: 14,
                boxShadow: '0 4px 24px rgba(0,0,0,0.13)',
                border: '2px solid #BFC0C2',
                maxWidth: '90vw',
                objectFit: 'contain',
              }}
            />
            <h1 style={{ fontSize: '2.7rem', fontWeight: 800, marginBottom: 12, letterSpacing: 1 }}>Welcome to The Vine Centre!</h1>
            <p style={{
              fontSize: '1.3rem',
              maxWidth: 600,
              margin: '0 auto 1.5rem auto',
              fontWeight: 500,
              textAlign: 'center'
            }}>
              Welcome to the Vine Centre – a hub for support, learning, and connection in North Belfast.
            </p>
            <Button
              variant="contained"
              href="/#/about"
              sx={{
                mt: 2,
                px: 4,
                py: 1.3,
                fontWeight: 800,
                fontSize: '1.13rem',
                borderRadius: 3,
                background: 'var(--vine-accent)',
                color: 'var(--vine-dark)',
                boxShadow: '0 2px 12px rgba(123,30,58,0.10)',
                textTransform: 'none',
                '&:hover': {
                  background: 'var(--vine-main)',
                  color: 'var(--vine-secondary)',
                },
              }}
            >
              Learn More
            </Button>
          </div>
        </div>

        {/* Feature Cards Section */}
        <section style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '2rem',
          width: '100%',
          margin: '2.5rem 0 2.5rem 0', // Add top margin for space between banner and cards
          padding: 0,
          background: 'none',
          boxShadow: 'none',
        }}>
        <div style={{
          flex: 1,
          minWidth: 260,
          background: 'var(--vine-secondary)',
          color: 'var(--vine-main)',
          borderRadius: 16,
          padding: '2rem 1.5rem',
          boxShadow: '0 2px 12px rgba(101,8,52,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}>
          <h2 style={{marginTop:0, fontSize:'1.5rem'}}>Who We Are</h2>
          <p>Learn about our mission, values, and the people behind the Vine Centre.</p>
          <a href="/#/about" style={{color:'var(--vine-main)',fontWeight:700,textDecoration:'underline'}}>About Us</a>
        </div>
        <div style={{
          flex: 1,
          minWidth: 260,
          background: 'var(--vine-main)',
          color: 'var(--vine-secondary)', // Use new palette's light color for contrast
          borderRadius: 16,
          padding: '2rem 1.5rem',
          boxShadow: '0 2px 12px rgba(101,8,52,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}>
          <h2 style={{marginTop:0, fontSize:'1.5rem', color: 'var(--vine-accent)'}}>What We Do</h2>
          <p>Discover our programmes, services, and how we support the community.</p>
          <a href="/#/programmes" style={{color:'var(--vine-secondary)',fontWeight:700,textDecoration:'underline'}}>Our Programmes</a>
        </div>
        <div style={{
          flex: 1,
          minWidth: 260,
          background: 'var(--vine-secondary)',
          color: 'var(--vine-main)',
          borderRadius: 16,
          padding: '2rem 1.5rem',
          boxShadow: '0 2px 12px rgba(101,8,52,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}>
          <h2 style={{marginTop:0, fontSize:'1.5rem'}}>Get In Touch</h2>
          <p>Contact us for more information or to get involved with the Vine Centre.</p>
          <a href="/#/contact" style={{color:'var(--vine-main)',fontWeight:700,textDecoration:'underline'}}>Contact Us</a>
        </div>

        {/* Facebook Card */}
        <div style={{
          flex: 1,
          minWidth: 260,
          background: 'var(--vine-main)',
          color: 'var(--vine-secondary)',
          borderRadius: 16,
          padding: '2rem 1.5rem',
          boxShadow: '0 2px 12px rgba(101,8,52,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <h2 style={{marginTop:0, fontSize:'1.5rem', color: 'var(--vine-accent)'}}>Follow us on Facebook</h2>
          <p style={{marginBottom: '1rem', color: 'var(--vine-secondary)', fontWeight: 500, textAlign: 'center'}}>
            Stay up to date with our latest news, events, and community updates.
          </p>
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fvinecentre193%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
            width="340"
            height="500"
            style={{ border: 'none', overflow: 'hidden', background: 'transparent', borderRadius: 8 }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            title="Vine Centre Facebook Page"
          ></iframe>
        </div>

      </section>
      </div>

      {/* Contact Section removed as requested */}
    </>
  );
}
